"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getSportActivities_1 = require("./graphql/getSportActivities");
const clock_1 = require("@almservices-cl/clock");
class SportActivityClient {
    constructor(client, adapter) {
        this.client = client;
        this.adapter = adapter;
        this.fetchSportActivities = async (userId, dateRange) => {
            const response = await this.client.fetch("fetchSportActivities", getSportActivities_1.getSportActivities, {
                userId: parseInt(userId),
                range: dateRange,
            });
            return this.adapter.adaptSportActivity(response.sportActivities, dateRange.from);
        };
        this.fetchSportActivitiesPerDate = async (userId, dateRange) => {
            const dates = (0, clock_1.getDatesOfDateRange)(dateRange);
            const res = await Promise.all(dates.map(this.fetchActivitiesPerDay(userId)));
            return {
                sportActivitiesPerDate: dates.map((date, index) => {
                    return {
                        date,
                        activitiesInDay: res[index].sportActivities.length,
                    };
                }),
            };
        };
        this.fetchActivitiesPerDay = (userId) => (date) => this.client.fetch("fetchSportActivitiesPerDay", getSportActivities_1.getSportActivitiesPerDay, {
            userId: parseInt(userId),
            range: { from: date, to: date },
        });
    }
}
exports.default = SportActivityClient;
//# sourceMappingURL=SportActivity.js.map